import ScrollToTop from '../components/ScrollToTop'
import Faq from '../components/Djado/Faq'

export const DjadoFaq = () => {
  return (
    <>
      <ScrollToTop />
      <Faq />
    </>
  )
}


export default DjadoFaq